import {
    AfterContentInit,
    Directive,
    ElementRef,
    HostListener,
    Input,
    OnDestroy,
    OnInit
} from '@angular/core';
import { NavManagerService } from '../services/nav-manager.service';
import { DpadSelectableDirective } from './dpad-selectable.directive';
import { DpadContainerDirective } from './dpad-container.directive';

@Directive({
    selector: '[dpadZone]'
})
export class DpadZoneDirective implements OnInit, AfterContentInit, OnDestroy {

    @Input() dpadZone = '';

    dpadSelectables: DpadSelectableDirective[] = [];

    private lastFocus: DpadSelectableDirective;

    constructor(private elem: ElementRef,
                private navManager: NavManagerService,
                private container: DpadContainerDirective) {
    }

    ngOnInit(): void {
    }

    ngAfterContentInit(): void {
        this.navManager.add(this);
    }

    @HostListener('click', ['$event'])
    onClick(event) {
        event.stopPropagation();

        if (this.dpadSelectables.length === 0) {
            this.container.goToLastSelectedZone();
            return;
        }

        this.goToZone();
    }

    goToZone() {
        this.navManager.moveToZone(this.dpadZone);
        if (this.lastFocus) {
            this.lastFocus.focus();
            return;
        }

        this.focus();
    }

    setLastFocus(dir: DpadSelectableDirective) {
        this.lastFocus = dir;
    }

    addSelectable(selectable: DpadSelectableDirective) {
        if (!this.dpadSelectables.find(f => f == selectable)) {
            this.dpadSelectables.push(selectable);
        }
    }

    removeSelectable(selectable: DpadSelectableDirective) {
        const index = this.dpadSelectables.indexOf(selectable);
        if (index > -1) {
            this.dpadSelectables.splice(index, 1);
        }
    }

    ngOnDestroy(): void {
        this.navManager.remove(this.dpadZone);
    }

    x(): number {
        return this.elem.nativeElement.getBoundingClientRect().x;
    }

    xEnd(): number {
        return this.elem.nativeElement.getBoundingClientRect().x + this.elem.nativeElement.offsetWidth;
    }

    xMid(): number {
        return this.elem.nativeElement.getBoundingClientRect().x + (this.elem.nativeElement.offsetWidth / 2);
    }

    y(): number {
        return this.elem.nativeElement.getBoundingClientRect().y;
    }

    yEnd(): number {
        return this.elem.nativeElement.getBoundingClientRect().y + this.elem.nativeElement.offsetHeight;
    }

    yMid(): number {
        return this.elem.nativeElement.getBoundingClientRect().y + (this.elem.nativeElement.offsetHeight / 2);
    }

    focus() {
        let zoneStart = this.dpadSelectables.find((f: { zoneStart: () => boolean; }) => f.zoneStart() === true);
        let start = this.dpadSelectables.find((f: { start: () => boolean; }) => f.start() === true);

        if (zoneStart) {
            zoneStart.focus();
            return true;
        } else if (start) {
            start.focus();
            return true;
        } else if (this.dpadSelectables.length > 0) {
            let dzero = this.dpadSelectables.find(f => f.dindex === 0);
            if (dzero) {
                dzero.focus();
            } else {
                this.dpadSelectables[0].focus();
            }
            return true;
        }
        return false;
    }

    selected() {
        if (this.dpadSelectables.find((f: { selected: () => any; }) => f.selected())) {
            return true;
        }
        return false;
    }
}

DpadZoneDirective.prototype.toString = function () {
    return this.dpadZone;
};
